// // // pages/assessment/FolderAssessments.jsx
// // import { useState, useEffect } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import {
// //   Box,
// //   Typography,
// //   Grid,
// //   Card,
// //   CardContent,
// //   CardActions,
// //   Button,
// //   IconButton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   MenuItem,
// //   Alert,
// //   CircularProgress,
// //   Breadcrumbs,
// //   Link,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import EditIcon from "@mui/icons-material/Edit";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // import QuizIcon from "@mui/icons-material/Quiz";
// // import { useATS } from "../atsModule/context/ATSContext";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // const FolderAssessments = () => {
// //   const { folderId } = useParams();
// //   const navigate = useNavigate();
// //   const { store_id } = useATS();
// //   const [folder, setFolder] = useState(null);
// //   const [assessments, setAssessments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editingAssessment, setEditingAssessment] = useState(null);
// //   const [formData, setFormData] = useState({
// //     title: "",
// //     description: "",
// //     max_score: 100,
// //     passing_score: 70,
// //     duration_minutes: 30,
// //     status: "DRAFT",
// //   });
// //   const [submitLoading, setSubmitLoading] = useState(false);

// //   const fetchData = async () => {
// //     if (!store_id && store_id !== 0) return;
// //     try {
// //       setLoading(true);
// //       // Get folder name (optional)
// //       const foldersRes = await axios.get(
// //         `${API_BASE}/api/assessment/assessment-folders`,
// //         {
// //           params: { store_id },
// //         },
// //       );
// //       const currentFolder = foldersRes.data.data.find(
// //         (f) => f.id === parseInt(folderId),
// //       );
// //       setFolder(currentFolder);
// //       // Get assessments in this folder
// //       const assessmentsRes = await axios.get(
// //         `${API_BASE}/api/assessment/assessments/folder/${folderId}`,
// //         {
// //           params: { store_id },
// //         },
// //       );
// //       setAssessments(assessmentsRes.data.data || []);
// //       setError("");
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load assessments");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //   }, [folderId, store_id]);

// //   const handleOpenModal = (assessment = null) => {
// //     if (assessment) {
// //       setEditingAssessment(assessment);
// //       setFormData({
// //         title: assessment.title,
// //         description: assessment.description || "",
// //         max_score: assessment.max_score,
// //         passing_score: assessment.passing_score,
// //         duration_minutes: assessment.duration_minutes,
// //         status: assessment.status,
// //       });
// //     } else {
// //       setEditingAssessment(null);
// //       setFormData({
// //         title: "",
// //         description: "",
// //         max_score: 100,
// //         passing_score: 70,
// //         duration_minutes: 30,
// //         status: "DRAFT",
// //       });
// //     }
// //     setModalOpen(true);
// //   };

// //   const handleCloseModal = () => {
// //     setModalOpen(false);
// //     setEditingAssessment(null);
// //   };

// //   const handleFormChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSaveAssessment = async () => {
// //     if (!formData.title.trim()) {
// //       alert("Title is required");
// //       return;
// //     }
// //     setSubmitLoading(true);
// //     try {
// //       const payload = {
// //         store_id,
// //         folder_id: parseInt(folderId),
// //         ...formData,
// //         max_score: Number(formData.max_score),
// //         passing_score: Number(formData.passing_score),
// //         duration_minutes: Number(formData.duration_minutes) || null,
// //       };
// //       if (editingAssessment) {
// //         await axios.put(
// //           `${API_BASE}/api/assessment/assessments/${editingAssessment.id}`,
// //           payload,
// //         );
// //       } else {
// //         await axios.post(`${API_BASE}/api/assessment/assessments`, payload);
// //       }
// //       fetchData();
// //       handleCloseModal();
// //     } catch (err) {
// //       console.error(err);
// //       alert(err.response?.data?.statusMessage || "Failed to save assessment");
// //     } finally {
// //       setSubmitLoading(false);
// //     }
// //   };

// //   const handleDeleteAssessment = async (assessmentId) => {
// //     if (
// //       !window.confirm(
// //         "Delete this assessment? All questions and user assignments will also be deleted.",
// //       )
// //     )
// //       return;
// //     try {
// //       await axios.delete(
// //         `${API_BASE}/api/assessment/assessments/${assessmentId}`,
// //         {
// //           data: { store_id },
// //         },
// //       );
// //       fetchData();
// //     } catch (err) {
// //       alert("Failed to delete assessment");
// //     }
// //   };

// //   const handleManageQuestions = (assessmentId) => {
// //     navigate(`/ats/assessments/assessment/${assessmentId}/questions`);
// //   };

// //   if (loading)
// //     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
// //   if (error) return <Alert severity="error">{error}</Alert>;

// //   return (
// //     <Box>
// //       <Breadcrumbs sx={{ mb: 2 }}>
// //         <Link
// //           component="button"
// //           variant="body2"
// //           onClick={() => navigate("/ats/assessments")}
// //         >
// //           Folders
// //         </Link>
// //         <Typography color="text.primary">
// //           {folder?.name || "Assessments"}
// //         </Typography>
// //       </Breadcrumbs>

// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           mb: 3,
// //         }}
// //       >
// //         <Typography variant="h4" fontWeight={600}>
// //           Assessments in {folder?.name || "Folder"}
// //         </Typography>
// //         <Button
// //           variant="contained"
// //           startIcon={<AddIcon />}
// //           onClick={() => handleOpenModal()}
// //           sx={{ bgcolor: "#1a2a3a" }}
// //         >
// //           New Assessment
// //         </Button>
// //       </Box>

// //       {assessments.length === 0 ? (
// //         <Alert severity="info">
// //           No assessments yet. Click "New Assessment" to create one.
// //         </Alert>
// //       ) : (
// //         <Grid container spacing={3}>
// //           {assessments.map((assessment) => (
// //             <Grid item xs={12} sm={6} md={4} key={assessment.id}>
// //               <Card sx={{ transition: "0.2s", "&:hover": { boxShadow: 3 } }}>
// //                 <CardContent>
// //                   <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// //                     <QuizIcon sx={{ fontSize: 30, color: "#e4c769", mr: 1 }} />
// //                     <Typography variant="h6" fontWeight={600}>
// //                       {assessment.title}
// //                     </Typography>
// //                   </Box>
// //                   {assessment.description && (
// //                     <Typography
// //                       variant="body2"
// //                       color="text.secondary"
// //                       sx={{ mb: 1 }}
// //                     >
// //                       {assessment.description}
// //                     </Typography>
// //                   )}
// //                   <Typography
// //                     variant="caption"
// //                     display="block"
// //                     color="text.secondary"
// //                   >
// //                     Max Score: {assessment.max_score} | Passing:{" "}
// //                     {assessment.passing_score}
// //                   </Typography>
// //                   <Typography
// //                     variant="caption"
// //                     display="block"
// //                     color="text.secondary"
// //                   >
// //                     Duration:{" "}
// //                     {assessment.duration_minutes
// //                       ? `${assessment.duration_minutes} min`
// //                       : "No limit"}
// //                   </Typography>
// //                   <Typography
// //                     variant="caption"
// //                     display="block"
// //                     color="text.secondary"
// //                   >
// //                     Status: {assessment.status}
// //                   </Typography>
// //                 </CardContent>
// //                 <CardActions sx={{ justifyContent: "flex-end" }}>
// //                   <Button
// //                     size="small"
// //                     onClick={() => handleManageQuestions(assessment.id)}
// //                     startIcon={<QuizIcon />}
// //                   >
// //                     Questions
// //                   </Button>
// //                   <IconButton
// //                     size="small"
// //                     onClick={() => handleOpenModal(assessment)}
// //                   >
// //                     <EditIcon fontSize="small" />
// //                   </IconButton>
// //                   <IconButton
// //                     size="small"
// //                     onClick={() => handleDeleteAssessment(assessment.id)}
// //                   >
// //                     <DeleteIcon fontSize="small" />
// //                   </IconButton>
// //                 </CardActions>
// //               </Card>
// //             </Grid>
// //           ))}
// //         </Grid>
// //       )}

// //       {/* Create/Edit Assessment Modal */}
// //       <Dialog
// //         open={modalOpen}
// //         onClose={handleCloseModal}
// //         maxWidth="sm"
// //         fullWidth
// //       >
// //         <DialogTitle>
// //           {editingAssessment ? "Edit Assessment" : "New Assessment"}
// //         </DialogTitle>
// //         <DialogContent>
// //           <TextField
// //             autoFocus
// //             margin="dense"
// //             label="Title"
// //             name="title"
// //             fullWidth
// //             value={formData.title}
// //             onChange={handleFormChange}
// //             required
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Description"
// //             name="description"
// //             fullWidth
// //             multiline
// //             rows={2}
// //             value={formData.description}
// //             onChange={handleFormChange}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Max Score"
// //             name="max_score"
// //             type="number"
// //             fullWidth
// //             value={formData.max_score}
// //             onChange={handleFormChange}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Passing Score"
// //             name="passing_score"
// //             type="number"
// //             fullWidth
// //             value={formData.passing_score}
// //             onChange={handleFormChange}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Duration (minutes)"
// //             name="duration_minutes"
// //             type="number"
// //             fullWidth
// //             value={formData.duration_minutes}
// //             onChange={handleFormChange}
// //             helperText="Leave empty for no time limit"
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Status"
// //             name="status"
// //             select
// //             fullWidth
// //             value={formData.status}
// //             onChange={handleFormChange}
// //           >
// //             <MenuItem value="DRAFT">Draft</MenuItem>
// //             <MenuItem value="PUBLISHED">Published</MenuItem>
// //             <MenuItem value="ARCHIVED">Archived</MenuItem>
// //           </TextField>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleCloseModal}>Cancel</Button>
// //           <Button
// //             onClick={handleSaveAssessment}
// //             variant="contained"
// //             disabled={submitLoading}
// //           >
// //             {submitLoading ? (
// //               <CircularProgress size={24} />
// //             ) : editingAssessment ? (
// //               "Update"
// //             ) : (
// //               "Create"
// //             )}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default FolderAssessments;

// // pages/assessment/FolderAssessments.jsx
// // ─── REDESIGNED UI ONLY — all logic/state/API calls are unchanged ───────────

// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   MenuItem,
//   Alert,
//   CircularProgress,
//   Breadcrumbs,
//   Link,
//   Chip,
//   Skeleton,
//   Tooltip,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import QuizIcon from "@mui/icons-material/Quiz";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
// import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
// import StarOutlineIcon from "@mui/icons-material/StarOutline";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // ─── Design tokens ────────────────────────────────────────────────────────────
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   900: "#1e3a8a",
// };

// const STATUS_CONFIG = {
//   DRAFT: { label: "Draft", color: "#92400e", bg: "#fef3c7", border: "#fde68a" },
//   PUBLISHED: {
//     label: "Published",
//     color: "#0c8a9b",
//     bg: "#d4f6fa",
//     border: "#0c8a9b",
//   },
//   ARCHIVED: {
//     label: "Archived",
//     color: "#4b5563",
//     bg: "#f3f4f6",
//     border: "#d1d5db",
//   },
// };

// const CARD_ACCENTS = [
//   { from: "#eff6ff", to: "#dbeafe", icon: "#2563eb" },
//   { from: "#f0fdf4", to: "#dcfce7", icon: "#16a34a" },
//   { from: "#fdf4ff", to: "#fae8ff", icon: "#9333ea" },
//   { from: "#fff7ed", to: "#ffedd5", icon: "#ea580c" },
//   { from: "#f0f9ff", to: "#e0f2fe", icon: "#0891b2" },
//   { from: "#fefce8", to: "#fef9c3", icon: "#ca8a04" },
// ];

// // ─── Inject keyframes once ────────────────────────────────────────────────────
// if (
//   typeof document !== "undefined" &&
//   !document.getElementById("fa-keyframes")
// ) {
//   const s = document.createElement("style");
//   s.id = "fa-keyframes";
//   s.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
//     @keyframes fadeUp   { from { opacity:0; transform:translateY(22px); } to { opacity:1; transform:translateY(0); } }
//     @keyframes fadeIn   { from { opacity:0; }                             to { opacity:1; }                          }
//     @keyframes floatBob { 0%,100% { transform:translateY(0);  } 50% { transform:translateY(-7px); } }
//   `;
//   document.head.appendChild(s);
// }

// // ─── Shared sx helpers ────────────────────────────────────────────────────────
// const fontFamily = "'Plus Jakarta Sans', sans-serif";

// const primaryBtnSx = {
//   background: "#0c8a9b",
//   color: "#fff",
//   borderRadius: "12px",
//   px: 2.5,
//   py: 1,
//   fontFamily,
//   fontWeight: 600,
//   fontSize: "0.875rem",
//   boxShadow: `0 4px 14px #0c8a9b`,
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: `0 8px 22px #0c8a9b`,
//     background: `linear-gradient(135deg, #0c8a9b0%, #0c8a9b 100%)`,
//   },
//   transition: "all .2s ease",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     fontFamily,
//     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BLUE[400] },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: BLUE[600],
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": { color: BLUE[600] },
//   "& .MuiFormHelperText-root": { fontFamily },
// };

// // ─── Skeleton card ────────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Card
//     sx={{
//       borderRadius: "20px",
//       boxShadow: "0 4px 20px rgba(0,0,0,.05)",
//       background: "#fff",
//     }}
//   >
//     <CardContent sx={{ p: 3 }}>
//       <Skeleton
//         variant="rounded"
//         width={48}
//         height={48}
//         sx={{ borderRadius: "12px", mb: 2 }}
//       />
//       <Skeleton variant="text" width="65%" height={26} />
//       <Skeleton variant="text" width="85%" height={20} sx={{ mt: 0.5 }} />
//       <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//         <Skeleton
//           variant="rounded"
//           width={70}
//           height={22}
//           sx={{ borderRadius: "6px" }}
//         />
//         <Skeleton
//           variant="rounded"
//           width={90}
//           height={22}
//           sx={{ borderRadius: "6px" }}
//         />
//       </Box>
//     </CardContent>
//     <CardActions sx={{ px: 3, pb: 2 }}>
//       <Skeleton
//         variant="rounded"
//         width={110}
//         height={34}
//         sx={{ borderRadius: "10px" }}
//       />
//     </CardActions>
//   </Card>
// );

// // ─── Empty state ──────────────────────────────────────────────────────────────
// const EmptyState = ({ folderName, onAdd }) => (
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       py: 12,
//       gap: 2,
//       animation: "fadeUp .5s ease both",
//     }}
//   >
//     <Box
//       sx={{
//         width: 88,
//         height: 88,
//         borderRadius: "50%",
//         background: `linear-gradient(135deg, ${BLUE[100]} 0%, ${BLUE[200]} 100%)`,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         animation: "floatBob 3s ease-in-out infinite",
//         boxShadow: `0 8px 24px ${BLUE[200]}`,
//       }}
//     >
//       <QuizIcon sx={{ fontSize: 40, color: BLUE[600] }} />
//     </Box>
//     <Typography
//       variant="h6"
//       fontWeight={700}
//       color="#0f172a"
//       sx={{ fontFamily }}
//     >
//       No assessments in {folderName || "this folder"}
//     </Typography>
//     <Typography variant="body2" color="text.secondary" sx={{ fontFamily }}>
//       Add your first assessment to get started.
//     </Typography>
//     <Button
//       variant="contained"
//       startIcon={<AddIcon />}
//       onClick={onAdd}
//       sx={primaryBtnSx}
//     >
//       New Assessment
//     </Button>
//   </Box>
// );

// // ─── Stat pill ─────────────────────────────────────────────────────────────────
// const StatPill = ({ icon, label }) => (
//   <Box
//     sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#64748b" }}
//   >
//     {icon}
//     <Typography variant="caption" sx={{ fontFamily, fontWeight: 500 }}>
//       {label}
//     </Typography>
//   </Box>
// );

// // ─── Main component ───────────────────────────────────────────────────────────
// const FolderAssessments = () => {
//   const { folderId } = useParams();
//   const navigate = useNavigate();
//   const { store_id } = useATS();

//   // ── original state (unchanged) ──
//   const [folder, setFolder] = useState(null);
//   const [assessments, setAssessments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingAssessment, setEditingAssessment] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     max_score: 100,
//     passing_score: 70,
//     duration_minutes: 30,
//     status: "DRAFT",
//   });
//   const [submitLoading, setSubmitLoading] = useState(false);

//   // ── original handlers (unchanged) ──
//   const fetchData = async () => {
//     if (!store_id && store_id !== 0) return;
//     try {
//       setLoading(true);
//       const foldersRes = await axios.get(
//         `${API_BASE}/api/assessment/assessment-folders`,
//         { params: { store_id } },
//       );
//       const currentFolder = foldersRes.data.data.find(
//         (f) => f.id === parseInt(folderId),
//       );
//       setFolder(currentFolder);
//       const assessmentsRes = await axios.get(
//         `${API_BASE}/api/assessment/assessments/folder/${folderId}`,
//         { params: { store_id } },
//       );
//       setAssessments(assessmentsRes.data.data || []);
//       setError("");
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load assessments");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [folderId, store_id]);

//   const handleOpenModal = (assessment = null) => {
//     if (assessment) {
//       setEditingAssessment(assessment);
//       setFormData({
//         title: assessment.title,
//         description: assessment.description || "",
//         max_score: assessment.max_score,
//         passing_score: assessment.passing_score,
//         duration_minutes: assessment.duration_minutes,
//         status: assessment.status,
//       });
//     } else {
//       setEditingAssessment(null);
//       setFormData({
//         title: "",
//         description: "",
//         max_score: 100,
//         passing_score: 70,
//         duration_minutes: 30,
//         status: "DRAFT",
//       });
//     }
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setEditingAssessment(null);
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSaveAssessment = async () => {
//     if (!formData.title.trim()) {
//       alert("Title is required");
//       return;
//     }
//     setSubmitLoading(true);
//     try {
//       const payload = {
//         store_id,
//         folder_id: parseInt(folderId),
//         ...formData,
//         max_score: Number(formData.max_score),
//         passing_score: Number(formData.passing_score),
//         duration_minutes: Number(formData.duration_minutes) || null,
//       };
//       if (editingAssessment) {
//         await axios.put(
//           `${API_BASE}/api/assessment/assessments/${editingAssessment.id}`,
//           payload,
//         );
//       } else {
//         await axios.post(`${API_BASE}/api/assessment/assessments`, payload);
//       }
//       fetchData();
//       handleCloseModal();
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.statusMessage || "Failed to save assessment");
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const handleDeleteAssessment = async (assessmentId) => {
//     if (
//       !window.confirm(
//         "Delete this assessment? All questions and user assignments will also be deleted.",
//       )
//     )
//       return;
//     try {
//       await axios.delete(
//         `${API_BASE}/api/assessment/assessments/${assessmentId}`,
//         { data: { store_id } },
//       );
//       fetchData();
//     } catch (err) {
//       alert("Failed to delete assessment");
//     }
//   };

//   const handleManageQuestions = (assessmentId) => {
//     navigate(`/ats/assessments/assessment/${assessmentId}/questions`);
//   };

//   // ── render ──
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily,
//         p: { xs: 2, sm: 4 },
//         borderRadius: 1.5,
//       }}
//     >
//       {/* ── Breadcrumbs ───────────────────────────────────────────────────── */}
//       <Breadcrumbs
//         separator={
//           <NavigateNextIcon fontSize="small" sx={{ color: "#94a3b8" }} />
//         }
//         sx={{ mb: 3, animation: "fadeIn .4s ease both" }}
//       >
//         <Link
//           component="button"
//           onClick={() => navigate("/ats/assessments")}
//           underline="hover"
//           sx={{
//             fontFamily,
//             fontWeight: 600,
//             fontSize: "0.85rem",
//             color: "#0c8a9b",
//             "&:hover": { color: "#0c8a9b" },
//           }}
//         >
//           Folders
//         </Link>
//         <Typography
//           sx={{
//             fontFamily,
//             fontWeight: 600,
//             fontSize: "0.85rem",
//             color: "#64748b",
//           }}
//         >
//           {folder?.name || "Assessments"}
//         </Typography>
//       </Breadcrumbs>

//       {/* ── Header ────────────────────────────────────────────────────────── */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           mb: 4,
//           flexWrap: "wrap",
//           gap: 2,
//           animation: "fadeUp .45s ease both",
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 800,
//               fontFamily,
//               color: "#0f172a",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             {folder?.name || "Assessments"}
//           </Typography>
//           {folder?.description && (
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{ mt: 0.5, fontFamily }}
//             >
//               {folder.description}
//             </Typography>
//           )}
//         </Box>

//         <Button
//           variant="contained"
//           startIcon={<AddIcon />}
//           onClick={() => handleOpenModal()}
//           sx={primaryBtnSx}
//         >
//           New Assessment
//         </Button>
//       </Box>

//       {/* ── Error ─────────────────────────────────────────────────────────── */}
//       {error && (
//         <Alert
//           severity="error"
//           sx={{ borderRadius: "14px", mb: 3, fontFamily }}
//         >
//           {error}
//         </Alert>
//       )}

//       {/* ── Loading skeletons ─────────────────────────────────────────────── */}
//       {loading && (
//         <Grid container spacing={3}>
//           {[...Array(6)].map((_, i) => (
//             <Grid item xs={12} sm={6} md={4} key={i}>
//               <SkeletonCard />
//             </Grid>
//           ))}
//         </Grid>
//       )}

//       {/* ── Empty state ───────────────────────────────────────────────────── */}
//       {!loading && !error && assessments.length === 0 && (
//         <EmptyState folderName={folder?.name} onAdd={() => handleOpenModal()} />
//       )}

//       {/* ── Assessment cards ──────────────────────────────────────────────── */}
//       {!loading && assessments.length > 0 && (
//         <Grid container spacing={3}>
//           {assessments.map((assessment, idx) => {
//             const accent = CARD_ACCENTS[idx % CARD_ACCENTS.length];
//             const status =
//               STATUS_CONFIG[assessment.status] || STATUS_CONFIG.DRAFT;
//             const delay = `${idx * 0.07}s`;
//             const passPercent = assessment.max_score
//               ? Math.round(
//                   (assessment.passing_score / assessment.max_score) * 100,
//                 )
//               : 0;

//             return (
//               <Grid item xs={12} sm={6} md={4} key={assessment.id}>
//                 <Card
//                   sx={{
//                     borderRadius: "20px",
//                     background: "#fff",
//                     boxShadow:
//                       "0 4px 20px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.04)",
//                     border: "1px solid rgba(226,232,240,0.8)",
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     animation: `fadeUp .5s ease ${delay} both`,
//                     transition: "all .25s cubic-bezier(.34,1.56,.64,1)",
//                     "&:hover": {
//                       transform: "scale(1.02) translateY(-4px)",
//                       boxShadow: `0 16px 40px rgba(37,99,235,.12), 0 4px 12px rgba(0,0,0,.06)`,
//                       borderColor: BLUE[200],
//                     },
//                     "&:hover .quiz-icon-wrap": {
//                       transform: "rotate(-8deg) scale(1.12)",
//                     },
//                   }}
//                 >
//                   <CardContent sx={{ p: 3, flex: 1 }}>
//                     {/* Icon + status row */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "flex-start",
//                         mb: 2,
//                       }}
//                     >
//                       <Box
//                         className="quiz-icon-wrap"
//                         sx={{
//                           width: 50,
//                           height: 50,
//                           borderRadius: "14px",
//                           background: `linear-gradient(135deg, ${accent.from} 0%, ${accent.to} 100%)`,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           transition: "transform .25s ease",
//                         }}
//                       >
//                         <QuizIcon sx={{ fontSize: 26, color: accent.icon }} />
//                       </Box>

//                       <Chip
//                         label={status.label}
//                         size="small"
//                         sx={{
//                           fontFamily,
//                           fontWeight: 600,
//                           fontSize: "0.72rem",
//                           color: status.color,
//                           background: status.bg,
//                           border: `1px solid ${status.border}`,
//                           borderRadius: "8px",
//                           height: 24,
//                         }}
//                       />
//                     </Box>

//                     {/* Title */}
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontWeight: 700,
//                         fontFamily,
//                         color: "#0f172a",
//                         fontSize: "1rem",
//                         mb: 0.5,
//                         display: "-webkit-box",
//                         WebkitLineClamp: 2,
//                         WebkitBoxOrient: "vertical",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {assessment.title}
//                     </Typography>

//                     {assessment.description && (
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: "#64748b",
//                           fontFamily,
//                           lineHeight: 1.5,
//                           mb: 2,
//                           display: "-webkit-box",
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                       >
//                         {assessment.description}
//                       </Typography>
//                     )}

//                     {/* Stats row */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         gap: 2,
//                         flexWrap: "wrap",
//                         mt: "auto",
//                         pt: 1.5,
//                         borderTop: "1px solid #f1f5f9",
//                       }}
//                     >
//                       <StatPill
//                         icon={<StarOutlineIcon sx={{ fontSize: 14 }} />}
//                         label={`Max: ${assessment.max_score}`}
//                       />
//                       <StatPill
//                         icon={<EmojiObjectsIcon sx={{ fontSize: 14 }} />}
//                         label={`Pass: ${passPercent}%`}
//                       />
//                       {assessment.duration_minutes && (
//                         <StatPill
//                           icon={<TimerOutlinedIcon sx={{ fontSize: 14 }} />}
//                           label={`${assessment.duration_minutes} min`}
//                         />
//                       )}
//                     </Box>
//                   </CardContent>

//                   <CardActions
//                     sx={{
//                       px: 3,
//                       pb: 2,
//                       pt: 0,
//                       justifyContent: "space-between",
//                       borderTop: "1px solid #f1f5f9",
//                     }}
//                   >
//                     <Button
//                       size="small"
//                       startIcon={
//                         <QuizIcon sx={{ fontSize: "16px !important" }} />
//                       }
//                       endIcon={
//                         <ArrowForwardIcon
//                           sx={{ fontSize: "14px !important" }}
//                         />
//                       }
//                       onClick={() => handleManageQuestions(assessment.id)}
//                       sx={{
//                         fontFamily,
//                         fontWeight: 600,
//                         color: "#0c8a9b",
//                         fontSize: "0.8rem",
//                         px: 1.5,
//                         py: 0.75,
//                         borderRadius: "8px",
//                         "&:hover": { background: "#0c8a9b33" },
//                       }}
//                     >
//                       Questions
//                     </Button>

//                     <Box sx={{ display: "flex", gap: 0.5 }}>
//                       <Tooltip title="Edit assessment">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleOpenModal(assessment)}
//                           sx={{
//                             color: "#94a3b8",
//                             borderRadius: "8px",
//                             "&:hover": {
//                               color: BLUE[600],
//                               background: BLUE[50],
//                             },
//                             transition: "all .15s",
//                           }}
//                         >
//                           <EditIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Delete assessment">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleDeleteAssessment(assessment.id)}
//                           sx={{
//                             color: "#94a3b8",
//                             borderRadius: "8px",
//                             "&:hover": {
//                               color: "#ef4444",
//                               background: "#fef2f2",
//                             },
//                             transition: "all .15s",
//                           }}
//                         >
//                           <DeleteIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </Box>
//                   </CardActions>
//                 </Card>
//               </Grid>
//             );
//           })}
//         </Grid>
//       )}

//       {/* ── Create / Edit modal ───────────────────────────────────────────── */}
//       <Dialog
//         open={modalOpen}
//         onClose={handleCloseModal}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "20px",
//             boxShadow: "0 25px 60px rgba(0,0,0,.15)",
//             fontFamily,
//             overflow: "hidden",
//           },
//         }}
//       >
//         {/* Accent strip */}
//         <Box
//           sx={{
//             height: 6,
//             background: `linear-gradient(90deg, "#0c8a9b" 0%, "#0c8a9b" 100%)`,
//           }}
//         />

//         <DialogTitle
//           sx={{
//             fontFamily,
//             fontWeight: 700,
//             fontSize: "1.15rem",
//             color: "#0f172a",
//             pt: 3,
//             pb: 0.5,
//           }}
//         >
//           {editingAssessment ? "Edit Assessment" : "New Assessment"}
//         </DialogTitle>

//         <DialogContent
//           sx={{ pt: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}
//         >
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Title"
//             name="title"
//             fullWidth
//             value={formData.title}
//             onChange={handleFormChange}
//             required
//             sx={inputSx}
//           />
//           <TextField
//             margin="dense"
//             label="Description"
//             name="description"
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.description}
//             onChange={handleFormChange}
//             sx={inputSx}
//           />

//           <Grid container spacing={2} sx={{ mt: 0 }}>
//             <Grid item xs={6}>
//               <TextField
//                 margin="dense"
//                 label="Max Score"
//                 name="max_score"
//                 type="number"
//                 fullWidth
//                 value={formData.max_score}
//                 onChange={handleFormChange}
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 margin="dense"
//                 label="Passing Score"
//                 name="passing_score"
//                 type="number"
//                 fullWidth
//                 value={formData.passing_score}
//                 onChange={handleFormChange}
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 margin="dense"
//                 label="Duration (minutes)"
//                 name="duration_minutes"
//                 type="number"
//                 fullWidth
//                 value={formData.duration_minutes}
//                 onChange={handleFormChange}
//                 helperText="Leave empty for no limit"
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 margin="dense"
//                 label="Status"
//                 name="status"
//                 select
//                 fullWidth
//                 value={formData.status}
//                 onChange={handleFormChange}
//                 sx={inputSx}
//               >
//                 <MenuItem value="DRAFT">Draft</MenuItem>
//                 <MenuItem value="PUBLISHED">Published</MenuItem>
//                 <MenuItem value="ARCHIVED">Archived</MenuItem>
//               </TextField>
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             onClick={handleCloseModal}
//             sx={{
//               fontFamily,
//               fontWeight: 600,
//               color: "#64748b",
//               borderRadius: "10px",
//               "&:hover": { background: "#f1f5f9" },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSaveAssessment}
//             variant="contained"
//             disabled={submitLoading}
//             sx={primaryBtnSx}
//           >
//             {submitLoading ? (
//               <CircularProgress size={20} sx={{ color: "#fff" }} />
//             ) : editingAssessment ? (
//               "Save Changes"
//             ) : (
//               "Create Assessment"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default FolderAssessments;
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Alert,
  CircularProgress,
  Breadcrumbs,
  Link,
  Skeleton,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Menu,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { useATS } from "../atsModule/context/ATSContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const TEAL = "#0c8a9b";
const FONT = "'DM Sans', 'Inter', sans-serif";

const STATUS_CONFIG = {
  DRAFT: { label: "Draft", color: "#92400e", bg: "#fef3c7" },
  PUBLISHED: { label: "Published", color: TEAL, bg: "#e6f6f8" },
  ARCHIVED: { label: "Archived", color: "#6b7280", bg: "#f3f4f6" },
};

const KF_ID = "fa-kf2";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const s = document.createElement("style");
  s.id = KF_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  `;
  document.head.appendChild(s);
}

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: FONT,
    fontSize: "0.9rem",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: TEAL },
};

// Row action menu
const RowMenu = ({ assessment, onEdit, onDelete }) => {
  const [anchor, setAnchor] = useState(null);
  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ color: "#adb5bd", borderRadius: "6px" }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0,0,0,.12)",
            minWidth: 140,
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onEdit(assessment);
          }}
          sx={{ fontFamily: FONT, fontSize: "0.85rem", gap: 1 }}
        >
          <EditIcon sx={{ fontSize: 15, color: "#868e96" }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onDelete(assessment.id);
          }}
          sx={{
            fontFamily: FONT,
            fontSize: "0.85rem",
            color: "#e03131",
            gap: 1,
          }}
        >
          <DeleteIcon sx={{ fontSize: 15 }} /> Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const FolderAssessments = () => {
  const { folderId } = useParams();
  const navigate = useNavigate();
  const { store_id } = useATS();

  const [folder, setFolder] = useState(null);
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingAssessment, setEditingAssessment] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    max_score: 100,
    passing_score: 70,
    duration_minutes: 30,
    status: "DRAFT",
  });
  const [submitLoading, setSubmitLoading] = useState(false);

  const fetchData = async () => {
    if (!store_id && store_id !== 0) return;
    try {
      setLoading(true);
      const foldersRes = await axios.get(
        `${API_BASE}/api/assessment/assessment-folders`,
        { params: { store_id } },
      );
      const currentFolder = foldersRes.data.data.find(
        (f) => f.id === parseInt(folderId),
      );
      setFolder(currentFolder);
      const assessmentsRes = await axios.get(
        `${API_BASE}/api/assessment/assessments/folder/${folderId}`,
        { params: { store_id } },
      );
      setAssessments(assessmentsRes.data.data || []);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load assessments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [folderId, store_id]);

  const handleOpenModal = (assessment = null) => {
    if (assessment) {
      setEditingAssessment(assessment);
      setFormData({
        title: assessment.title,
        description: assessment.description || "",
        max_score: assessment.max_score,
        passing_score: assessment.passing_score,
        duration_minutes: assessment.duration_minutes,
        status: assessment.status,
      });
    } else {
      setEditingAssessment(null);
      setFormData({
        title: "",
        description: "",
        max_score: 100,
        passing_score: 70,
        duration_minutes: 30,
        status: "DRAFT",
      });
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingAssessment(null);
  };
  const handleFormChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSaveAssessment = async () => {
    if (!formData.title.trim()) {
      alert("Title is required");
      return;
    }
    setSubmitLoading(true);
    try {
      const payload = {
        store_id,
        folder_id: parseInt(folderId),
        ...formData,
        max_score: Number(formData.max_score),
        passing_score: Number(formData.passing_score),
        duration_minutes: Number(formData.duration_minutes) || null,
      };
      if (editingAssessment) {
        await axios.put(
          `${API_BASE}/api/assessment/assessments/${editingAssessment.id}`,
          payload,
        );
      } else {
        await axios.post(`${API_BASE}/api/assessment/assessments`, payload);
      }
      fetchData();
      handleCloseModal();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.statusMessage || "Failed to save assessment");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDeleteAssessment = async (assessmentId) => {
    if (
      !window.confirm(
        "Delete this assessment? All questions and user assignments will also be deleted.",
      )
    )
      return;
    try {
      await axios.delete(
        `${API_BASE}/api/assessment/assessments/${assessmentId}`,
        { data: { store_id } },
      );
      fetchData();
    } catch (err) {
      alert("Failed to delete assessment");
    }
  };

  const handleManageQuestions = (assessmentId) => {
    navigate(`/ats/assessments/assessment/${assessmentId}/questions`);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f5f7fb",
        fontFamily: FONT,
        p: { xs: 2, md: 3.5 },
      }}
    >
      {/* ───────────────── HEADER ───────────────── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          mb: 3.5,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { xs: "1.6rem", md: "2rem" },
              fontWeight: 700,
              color: "#111827",
              fontFamily: FONT,
              letterSpacing: "-0.03em",
            }}
          >
            {folder?.name || "Assessment Hub"}
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              color: "#6b7280",
              fontSize: "0.92rem",
              fontFamily: FONT,
            }}
          >
            Organize, manage and evaluate candidate assessments efficiently.
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal()}
          sx={{
            background: "linear-gradient(135deg,#19c2b4,#63e6d8)",
            color: "#fff",
            borderRadius: "12px",
            px: 2.2,
            py: 1.1,
            fontSize: "0.86rem",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "none",
            minWidth: 180,
            "&:hover": {
              background: "linear-gradient(135deg,#15b3a5,#4dd4c6)",
              boxShadow: "none",
            },
          }}
        >
          Create Assessment
        </Button>
      </Box>

      {/* ───────────────── STATS ───────────────── */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2,1fr)",
            md: "repeat(4,1fr)",
          },
          gap: 2,
          mb: 3.5,
        }}
      >
        {[
          {
            label: "Total Assessments",
            value: assessments.length,
            bg: "#e8fffb",
            color: "#0f766e",
          },
          {
            label: "Published",
            value: assessments.filter((a) => a.status === "PUBLISHED").length,
            bg: "#ecfeff",
            color: "#0891b2",
          },
          {
            label: "Draft",
            value: assessments.filter((a) => a.status === "DRAFT").length,
            bg: "#fff7ed",
            color: "#ea580c",
          },
          {
            label: "Questions",
            value: assessments.reduce(
              (acc, curr) => acc + (curr.question_count || 0),
              0,
            ),
            bg: "#f3f0ff",
            color: "#7c3aed",
          },
        ].map((item, idx) => (
          <Box
            key={idx}
            sx={{
              background: "#fff",
              borderRadius: "20px",
              p: 2.3,
              border: "1px solid #edf2f7",
              boxShadow: "0 2px 10px rgba(15,23,42,0.04)",
            }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "14px",
                background: item.bg,
                mb: 1.6,
              }}
            />

            <Typography
              sx={{
                color: "#94a3b8",
                fontSize: "0.8rem",
                fontWeight: 600,
                mb: 0.5,
                fontFamily: FONT,
              }}
            >
              {item.label}
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.6rem",
                color: item.color,
                fontFamily: FONT,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* ───────────────── TABLE CARD ───────────────── */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "24px",
          border: "1px solid #edf2f7",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(15,23,42,0.04)",
        }}
      >
        {/* TOP BAR */}
        <Box
          sx={{
            px: 3,
            py: 2.2,
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.05rem",
                color: "#111827",
                fontFamily: FONT,
              }}
            >
              Assessments List
            </Typography>

            <Typography
              sx={{
                color: "#94a3b8",
                fontSize: "0.82rem",
                mt: 0.3,
                fontFamily: FONT,
              }}
            >
              {assessments.length} total assessments
            </Typography>
          </Box>

          <TextField
            size="small"
            placeholder="Search assessments..."
            sx={{
              width: { xs: "100%", md: 260 },

              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                background: "#f8fafc",
                fontFamily: FONT,
              },
            }}
          />
        </Box>

        {/* TABLE */}
        <TableContainer sx={{ overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  background: "#fafbfd",
                }}
              >
                {[
                  "Assessment",
                  "Questions",
                  "Score",
                  "Duration",
                  "Status",
                  "Created",
                  "",
                ].map((head) => (
                  <TableCell
                    key={head}
                    sx={{
                      borderBottom: "1px solid #eef2f7",
                      color: "#94a3b8",
                      fontSize: "0.73rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.08em",
                      py: 1.8,
                      fontFamily: FONT,
                    }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                [...Array(5)].map((_, i) => (
                  <TableRow key={i}>
                    {[...Array(7)].map((_, j) => (
                      <TableCell
                        key={j}
                        sx={{ borderBottom: "1px solid #f8fafc" }}
                      >
                        <Skeleton height={24} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : assessments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={{ py: 10, border: "none" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          background: "#e6f6f8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2,
                        }}
                      >
                        <QuizOutlinedIcon
                          sx={{
                            fontSize: 36,
                            color: TEAL,
                          }}
                        />
                      </Box>

                      <Typography
                        sx={{
                          fontWeight: 700,
                          color: "#111827",
                          fontFamily: FONT,
                        }}
                      >
                        No assessments found
                      </Typography>

                      <Typography
                        sx={{
                          color: "#94a3b8",
                          mt: 0.5,
                          fontSize: "0.9rem",
                          fontFamily: FONT,
                        }}
                      >
                        Start by creating your first assessment
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                assessments.map((assessment, idx) => {
                  const status =
                    STATUS_CONFIG[assessment.status] || STATUS_CONFIG.DRAFT;

                  return (
                    <TableRow
                      key={assessment.id}
                      sx={{
                        transition: ".18s",
                        "&:hover": {
                          background: "#fafcfd",
                        },
                        "& td": {
                          borderBottom: "1px solid #f5f7fa",
                        },
                      }}
                    >
                      {/* Assessment */}
                      <TableCell sx={{ py: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                          }}
                        >
                          <Box
                            sx={{
                              width: 44,
                              height: 44,
                              borderRadius: "14px",
                              background: "#e6f6f8",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <QuizOutlinedIcon
                              sx={{
                                color: TEAL,
                                fontSize: 22,
                              }}
                            />
                          </Box>

                          <Box>
                            <Typography
                              sx={{
                                fontWeight: 700,
                                fontSize: "0.92rem",
                                color: "#111827",
                                fontFamily: FONT,
                              }}
                            >
                              {assessment.title}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "0.78rem",
                                color: "#94a3b8",
                                maxWidth: 260,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontFamily: FONT,
                              }}
                            >
                              {assessment.description || "No description added"}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      {/* Questions */}
                      <TableCell>
                        <Chip
                          label={`${assessment.question_count || 0} Questions`}
                          sx={{
                            background: "#f1f5f9",
                            color: "#334155",
                            fontWeight: 600,
                            borderRadius: "8px",
                            fontFamily: FONT,
                          }}
                        />
                      </TableCell>

                      {/* Score */}
                      <TableCell>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              color: "#0f172a",
                              fontSize: "0.9rem",
                              fontFamily: FONT,
                            }}
                          >
                            {assessment.passing_score}/{assessment.max_score}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              color: "#94a3b8",
                              fontFamily: FONT,
                            }}
                          >
                            passing / max
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Duration */}
                      <TableCell>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#334155",
                            fontSize: "0.86rem",
                            fontFamily: FONT,
                          }}
                        >
                          {assessment.duration_minutes || 0} mins
                        </Typography>
                      </TableCell>

                      {/* Status */}
                      <TableCell>
                        <Chip
                          label={status.label}
                          sx={{
                            background: status.bg,
                            color: status.color,
                            fontWeight: 700,
                            borderRadius: "999px",
                            height: 28,
                            px: 0.8,
                            fontFamily: FONT,
                          }}
                        />
                      </TableCell>

                      {/* Date */}
                      <TableCell>
                        <Typography
                          sx={{
                            color: "#64748b",
                            fontSize: "0.83rem",
                            fontWeight: 500,
                            fontFamily: FONT,
                          }}
                        >
                          {assessment.created_at
                            ? new Date(
                                assessment.created_at,
                              ).toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              })
                            : "—"}
                        </Typography>
                      </TableCell>

                      {/* Actions */}
                      <TableCell align="right">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Button
                            onClick={() => handleManageQuestions(assessment.id)}
                            sx={{
                              background: "#f8fafc",
                              color: "#334155",
                              borderRadius: "10px",
                              px: 1.6,
                              py: 0.7,
                              fontSize: "0.78rem",
                              fontWeight: 600,
                              textTransform: "none",
                              fontFamily: FONT,
                              "&:hover": {
                                background: "#e6f6f8",
                                color: TEAL,
                              },
                            }}
                          >
                            Questions
                          </Button>

                          <RowMenu
                            assessment={assessment}
                            onEdit={handleOpenModal}
                            onDelete={handleDeleteAssessment}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* FOOTER */}
        {!loading && assessments.length > 0 && (
          <Box
            sx={{
              px: 3,
              py: 1.8,
              borderTop: "1px solid #f1f5f9",
              background: "#fcfcfd",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "#94a3b8",
                fontFamily: FONT,
              }}
            >
              Showing {assessments.length} assessments
            </Typography>
          </Box>
        )}
      </Box>

      {/* ── Create / Edit Modal ──────────────────────────────────────── */}
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            fontFamily: FONT,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: FONT,
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1a1d23",
            pt: 2.5,
            pb: 0.5,
          }}
        >
          {editingAssessment ? "Edit Assessment" : "New Assessment"}
        </DialogTitle>
        <DialogContent
          sx={{ pt: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}
        >
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            name="title"
            fullWidth
            value={formData.title}
            onChange={handleFormChange}
            required
            sx={inputSx}
          />
          <TextField
            margin="dense"
            label="Description"
            name="description"
            fullWidth
            multiline
            rows={2}
            value={formData.description}
            onChange={handleFormChange}
            sx={inputSx}
          />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 2,
              mt: 0.5,
            }}
          >
            <TextField
              margin="dense"
              label="Max Score"
              name="max_score"
              type="number"
              fullWidth
              value={formData.max_score}
              onChange={handleFormChange}
              sx={inputSx}
            />
            <TextField
              margin="dense"
              label="Passing Score"
              name="passing_score"
              type="number"
              fullWidth
              value={formData.passing_score}
              onChange={handleFormChange}
              sx={inputSx}
            />
            <TextField
              margin="dense"
              label="Duration (min)"
              name="duration_minutes"
              type="number"
              fullWidth
              value={formData.duration_minutes}
              onChange={handleFormChange}
              helperText="Leave empty for no limit"
              sx={inputSx}
            />
            <TextField
              margin="dense"
              label="Status"
              name="status"
              select
              fullWidth
              value={formData.status}
              onChange={handleFormChange}
              sx={inputSx}
            >
              <MenuItem value="DRAFT">Draft</MenuItem>
              <MenuItem value="PUBLISHED">Published</MenuItem>
              <MenuItem value="ARCHIVED">Archived</MenuItem>
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
          <Button
            onClick={handleCloseModal}
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              color: "#868e96",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": { background: "#f1f3f5" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveAssessment}
            variant="contained"
            disabled={submitLoading}
            sx={{
              background: TEAL,
              borderRadius: "8px",
              fontFamily: FONT,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
          >
            {submitLoading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : editingAssessment ? (
              "Save Changes"
            ) : (
              "Create Assessment"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FolderAssessments;
